import { token } from '@terra/ui-styled-system';

export const INTERNET_NODE_ID = '__internet__';

export const CLOUD_ACCOUNT_NODE_ID_PREFIX = '__cloud_account__:';
export const APPLICATION_NODE_ID_PREFIX = '__application__:';

export const isSyntheticGraphNodeId = (nodeId: string): boolean =>
  nodeId === INTERNET_NODE_ID ||
  nodeId.startsWith(CLOUD_ACCOUNT_NODE_ID_PREFIX) ||
  nodeId.startsWith(APPLICATION_NODE_ID_PREFIX);

export const GRAPH_COLORS = {
  background: token('colors.gray.6'),
};
